<template>
  <div class="screenLoading">
    <div class="lang_select" :class="routeType? '':'iphoneStyle'">
      <router-link class="lang_zh" :to="{ path: '/zh/index' }">
        <div class="zh_first">中文</div>
        <div class="zh_content">
          <div class="item">为不可预测的未来</div>
          <div class="item">培养具有国际思维的时代精英</div>
        </div>
      </router-link>
      <!-- <div class="lang_zh" @click="handleSelectLang('zh')">
        <div class="zh_first">中文</div>
        <div class="zh_content">
          <div class="item">为不可预测的未来</div>
          <div class="item">培养具有国际思维的时代精英</div>
        </div>
      </div>-->
      <router-link class="lang_en" :to="{ path: '/en/index' }">
        <div class="en_first">ENGLISH</div>
        <div class="en_content">Cultivate Elites With An International Vision To Rise Above Whatever Tomorrow Brings</div>
      </router-link>
      <!-- <div class="lang_en" @click="handleSelectLang('en')">
        <div class="en_first">ENGLISH</div>
        <div class="en_content">Cultivate Elites With An International Vision To Rise Above Whatever Tomorrow Brings</div>
      </div>-->
    </div>
    <!-- 底部透明条 -->
    <div class="intro">金成教育集团 Jincheng Education Group</div>
    <a href="/wap/screenLoading" class="jump">跳转到移动</a>
  </div>
</template> 

<script>

export default {
  name: 'screenLoading',
  data () {
    return {
      routeType: true
    }
  },
  inject: ['reload'],
  //挂载
  created () {
      let width = document.documentElement.clientWidth;
      let lang = localStorage.getItem('language') || ""
      // var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
      //获取浏览器配置语言 #括号内是个运算，运算过后赋值给lang，当?前的内容为true时把?后的值赋给lang，为False时把:后的值赋给lang
      // var lang = lang.substr(0, 2);//获取lang字符串的前两位
      let url = ''
      if (width > 1024) {
        this.routeType = true
        url = ''
      } else {
        this.routeType = false
        url = '/wap'
      }
      if (lang && lang == 'zh') {
        this.$router.push({
          path: url + '/zh/index'
        })
      } else if (lang && lang == 'en') {
        this.$router.push({
          path: url + '/en/index'
        })
      } else {
        if (width < 1024) {
          this.$router.push({
            path: '/wap/screenLoading'
          })
        }
      }
  },
  methods: {
    // handleSelectLang (lang) {
    //   let width = document.documentElement.clientWidth; //clientWidth网页可见区域的高度
    //   if (width > 1024) {
    //     console.log('我是PC')
    //     this.$router.push({ path: '/' + lang + '/index' })
    //   } else {
    //     console.log('我是移动')
    //     this.$router.push({ path: '/wap/' + lang + '/index' })
    //   }
    //   // this.$router.go(0)
    //   // this.reload()
    // }
  }
}
</script>

<style scoped="scoped">
.screenLoading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  z-index: 99;
  background: url('/static/img/screenLoading.png') no-repeat;
  background-size: cover;
  overflow: hidden;
}
.lang_select {
  width: 6rem;
  height: 0.95rem;
  font-family: MicrosoftYaHei;
  font-weight: Regular;
  color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
}
.lang_select a {
  color: #ffffff;
}
.lang_zh,
.lang_en {
  width: 3rem;
  height: 100%;
  background-color: #175f9f;
  text-align: center;
  cursor: pointer;
}
.lang_zh,
.lang_en {
  float: left;
}
.lang_zh:hover,
.lang_en:hover {
  background-color: #083b69;
  box-shadow: 0px 2px 19px 0px rgba(25, 53, 83, 0.22);
}
/* .lang_en{
  background-color: #083B69;
  box-shadow:0px 2px 19px 0px rgba(25,53,83,0.22);
} */
.zh_first,
.en_first {
  font-size: 0.16rem;
  padding-top: 0.15rem;
}
.zh_content,
.en_content {
  font-size: 0.1rem;
  margin-top: 0.08rem;
}
.en_content {
  padding: 0 0.15rem;
}
.intro {
  text-align: center;
  font-size: 0.17rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  height: 0.43rem;
  line-height: 0.43rem;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.iphoneStyle {
  height: 2rem;
  transform: translate(-50%, -50%);
}
.jump {
  position: absolute;
  left: -99999px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/screenLoading.vue